import { useCallback, useEffect, useMemo, useState } from "react";

export default function useSorting({ data = [], fieldNames = [{}], defaultSort = null }) {
  if (defaultSort && typeof defaultSort === "string") {
    defaultSort = fieldNames.find((x) => x?.title === defaultSort);
  }

  const [sort, setSort] = useState(defaultSort || fieldNames[0]);
  const [sortDesc, setSortDesc] = useState(true);

  useEffect(() => {
    if (sort && !fieldNames.find((x) => x.title === sort.title)) {
      setSort(defaultSort || fieldNames[0]);
      setSortDesc(true);
    }
  }, [fieldNames]);

  const sorted = useMemo(() => {
    if (!data) {
      return [];
    }

    let sorted = [...data];
    const sortMult = sortDesc ? 1 : -1;
    sorted.sort((a, b) => sortMult * (b[sort?.key] - a[sort?.key]));
    return sorted;
  }, [data, sort, sortDesc]);

  const handleSetSort = useCallback(
    (sortField) => {
      if (sort?.title === sortField) {
        setSortDesc((prev) => !prev);
        return;
      }

      const newSort = fieldNames.find((x) => {
        return x?.title === sortField;
      });
      setSort(newSort);
      setSortDesc(true);
    },
    [sort, fieldNames],
  );

  const sortClass = useMemo(() => {
    if (sortDesc) {
      return "table-sort-desc";
    } else {
      return "table-sort-asc";
    }
  }, [sortDesc]);

  return {
    sorted,
    setSort: handleSetSort,
    sortClass,
    sortMetric: sort?.title,
  };
}
